/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export const shiftActivityStatusEnum = {
  not_started: 'not_started',
  in_progress: 'in_progress',
  completed: 'completed',
} as const;

export type ShiftActivityStatusEnumSchemaKey = (typeof shiftActivityStatusEnum)[keyof typeof shiftActivityStatusEnum];

export type ShiftActivityStatusSchema = ShiftActivityStatusEnumSchemaKey;
